//Will return false if the list includes the personnel, and true if the list does not include personnel
const duplicatePersonnelNameValidation = (personnels, personnel) => {
  let nameOnlyPersonnelsList = personnels.map(
    (p) => p.firstName.toLowerCase().trim() + p.lastName.toLowerCase().trim()
  );
  const fullName =
    personnel.firstName.toLowerCase().trim() +
    personnel.lastName.toLowerCase().trim();
  if (nameOnlyPersonnelsList.includes(fullName)) {
    return false;
  }

  return true;
};

export default duplicatePersonnelNameValidation;
